import styled from 'styled-components';
import { CssSpace } from '@xbcb/ui-types';

export const StyledUnitAssistInputMinusButtonWrapperDiv = styled.div`
  display: inline-block;
  margin-left: calc(${CssSpace.SPACE_3} * -1);
  margin-right: ${CssSpace.SPACE_4};
`;
